declare module "react" {
  // eslint-disable-next-line @typescript-eslint/no-namespace
  namespace JSX {
    interface IntrinsicElements {
      "web-component-test": React.DetailedHTMLProps<
        React.HTMLAttributes<HTMLElement> & {
          "bg-color"?: string;
          message?: string;
          title?: string;
        },
        HTMLElement
      >;
    }
  }
}

export class InfoBox extends HTMLElement {
  static get observedAttributes() {
    return ["message", "bg-color", "title"];
  }

  constructor() {
    super();
    this.attachShadow({ mode: "open" });
    this.render();
  }

  attributeChangedCallback() {
    this.render();
  }

  render() {
    if (!this.shadowRoot) return;
    const message =
      this.getAttribute("message") || "This is a Web Component Example!";
    const bgColor = this.getAttribute("bg-color") || "#e9ecef";
    const title = this.getAttribute("title");
    this.shadowRoot.innerHTML = /* html */ `
      <style>
        .web-component-test {
          padding: 15px;
          margin: 15px 0;
          background-color: ${bgColor};
          border-radius: 4px;
          box-shadow: 0 2px 4px rgba(0,0,0,0.1);
        }
        .title {
          margin: 0 0 10px 0;
          font-weight: bold;
          font-family: system-ui, -apple-system, sans-serif;
        }
        p {
          margin: 0;
          color: #495057;
          font-family: system-ui, -apple-system, sans-serif;
        }
      </style>
      <div class="web-component-test">
        ${title ? `<h3 class="title">${title}</h3>` : ""}
        <p>${message}</p>
      </div>
    `;
  }
}

// Only register the web component if we're in a browser environment
if (typeof window !== "undefined") {
  if (!customElements.get("web-component-test")) {
    customElements.define("web-component-test", InfoBox);
  }
}
